<template>
    <div>
        <mq-layout mq="wide">
            <div class="main-category" ref="mainCateContainer"
                 @mouseenter="onMouseEnter"
                 @mouseleave="onMouseLeave"
                 v-show="isShowDesktopMenu"
            >
                <ul>
                    <li
                        v-for="(cateItem, cateIndex) in storeCate.cateItem"
                        :style="styleCateItem(cateItem.color, cateItem.bgcolor)"
                        v-show="cateItem.display"

                    >
                        <template v-if="cateItem.icon">
                            <div>
                                <img :src="`/${cateItem.icon}`">
                            </div>
                        </template>

                            <p :style="'color:'+cateItem.color" v-html="cateItem.title"></p>
                            <ul
                                class="sub-cat"
                                :style="styleSubCateItem(cateItem.color, cateItem.bgcolor)"
                                :class="classCateItem(cateIndex)"
                            >
                                <li
                                    v-for ="(subcateItem, subcateItemIndex) in cateItem.subcate"
                                    v-show="subcateItem.display"

                                >
                                    <a
                                        :style="styleSubCateLink(subcateItem.color)"
                                        @click.prevent="handleSubCateAction(subcateItem.action, subcateItem.action_value, cateItem.id, subcateItem.id)"
                                    >
                                        <span
                                            v-html="subcateItem.title"
                                            :style="styleSubCateLink(subcateItem.color)"
                                        >
                                        </span>
                                    </a>
                                </li>
                            </ul>
                    </li>
                </ul>
            </div>
        </mq-layout>
        <mq-layout mq="narrow">
            <!--mobile left menu-->
            <div class="mobile-left-menu" v-show="isShowMobileMenu" ref="mobileMenu">
                <!--head-->
                <div class="mobile-menu-head">
                    <template v-if="showLoginBtn">
                        <div class="head-lv1">
                            <div>
                                <div class="profile-pic">
                                    <img :src='member_avatar'>
                                </div>
                                <div class="profile-name">
                                    <span>{{ lang($t(userrole)) }}</span>
                                    <p>{{ display_name }}</p>
                                </div>
                            </div>
                            <div>
                                <a class="btn-menu dark"
                                   @click.prevent="closeMobileMenu">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                            <path d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z"></path>
                                        </svg>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </template>

                    <div class="head-lv2">
                        <div class="bg-secondary hover-dim"
                             @click.prevent="showMyDownload"
                        >
                            {{ lang($t("Download")) }}
                        </div>
                        <div class="bg-secondary hover-dimmer"
                             @click.prevent="showSetting"
                        >
                            {{ lang($t("Settings")) }}</div>

                        <template v-if="showLoginBtn">
                            <div class="bg-secondary hover-dimmer" @click="logout">
                                {{ lang($t("Log out")) }}</div>
                        </template>
                    </div>
                </div>
                <div class="mobile-menu-body">
                    <ul>
                        <li
                            v-for="(cateItem, cateIndex) in storeCate.cateItem"
                            :style="styleCateItem(cateItem.color)"
                            v-show="cateItem.display"
                        >
                            <p v-html="cateItem.title"></p>
                            <ul>
                                <li
                                    v-for ="(subcateItem, subcateItemIndex) in cateItem.subcate"
                                    v-show="subcateItem.display"
                                >
                                    <a @click.prevent="handleSubCateAction(subcateItem.action, subcateItem.action_value,  cateItem.id, subcateItem.id)">
                                      <p v-html="subcateItem.title"></p>
                                    </a>
                                </li>
                            </ul>
                            <div class="indicator"
                                 :style="styleMobileCateIndicator(cateItem.bgcolor)"
                            >
                            </div>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="box-model view-full mobile-normal-list" v-show="isShowMobileSetting">

                <!--head-->
                <div class="head">

                    <div class="head-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path d="M39.998,30c-5.514,0-10,4.486-10,10s4.486,10,10,10s10-4.486,10-10S45.512,30,39.998,30z"/>
                            <path d="M79.496,33.933c-0.189-1.249-1.052-2.292-2.241-2.714l-6.303-2.241c-0.373-1.056-0.796-2.083-1.265-3.075l2.868-6.035
		c0.542-1.139,0.413-2.484-0.335-3.503c-2.417-3.288-5.305-6.176-8.584-8.582c-1.02-0.747-2.361-0.875-3.502-0.332l-6.031,2.866
		c-0.994-0.469-2.021-0.891-3.078-1.264l-2.242-6.304c-0.422-1.187-1.462-2.046-2.709-2.238c-4.431-0.681-7.71-0.681-12.147,0
		c-1.245,0.192-2.287,1.052-2.709,2.238l-2.242,6.304c-1.057,0.373-2.085,0.795-3.077,1.264L19.864,7.45
		c-1.138-0.542-2.482-0.415-3.5,0.332c-3.279,2.406-6.168,5.294-8.585,8.582c-0.748,1.019-0.876,2.364-0.335,3.503l2.868,6.035
		c-0.469,0.99-0.891,2.02-1.264,3.075l-6.304,2.243c-1.189,0.422-2.049,1.465-2.24,2.712C0.161,36.191,0,38.117,0,40.002
		c0,1.881,0.161,3.811,0.504,6.068c0.189,1.25,1.051,2.293,2.241,2.715l6.303,2.24c0.373,1.059,0.797,2.086,1.264,3.078
		l-2.868,6.033c-0.542,1.139-0.413,2.484,0.334,3.5c2.414,3.285,5.302,6.174,8.586,8.584c1.018,0.748,2.362,0.878,3.501,0.333
		l6.031-2.866c0.994,0.469,2.021,0.891,3.078,1.264l2.242,6.303c0.422,1.188,1.463,2.047,2.709,2.239C36.143,79.834,38.129,80,40,80
		c1.87,0,3.857-0.166,6.073-0.507c1.247-0.192,2.286-1.052,2.709-2.239l2.241-6.303c1.058-0.373,2.086-0.795,3.078-1.264
		l6.033,2.866c1.141,0.544,2.484,0.415,3.502-0.333c3.287-2.414,6.176-5.303,8.585-8.584c0.747-1.016,0.875-2.361,0.333-3.5
		l-2.867-6.033c0.469-0.992,0.891-2.021,1.264-3.078l6.303-2.24c1.189-0.422,2.052-1.465,2.241-2.715
		C79.84,43.813,80,41.884,80,40.002S79.84,36.191,79.496,33.933z M39.998,60c-11.028,0-20-8.973-20-20c0-11.028,8.973-20,20-20
		s20,8.972,20,20C59.998,51.027,51.025,60,39.998,60z"/>
                        </svg>
                    </div>

                    <h2>{{ lang($t("Settings")) }}</h2>
                    <a class="btn-close dark"
                       @click.prevent="closeSetting"
                    >
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                <path d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z"/>
                            </svg>
                        </div>
                    </a>
                </div>
                <!--end head-->

                <!--body-->
                <div class="body">
                    <div>
                        <p>{{ lang($t("Language")) }}</p>
                        <div class="switch-btn-group" v-show="this.storeMainSite.relation !== null">
                            <a :href="relation_url" class="system-btn btn-primary"> {{ relation_lang }}</a>
                        </div>
                    </div>
                    <div><a href="#" @click.prevent="redirectTo('Terms')"><p>{{ lang($t("Terms and Conditions")) }}</p></a></div>
                    <div><a href="#" @click.prevent="redirectTo('Disclaimer')"><p>{{ lang($t("Disclaimer")) }}</p></a></div>
                    <div><a href="#" @click.prevent="redirectTo('ContactUs')"><p>{{ lang($t("Contact Us")) }}</p></a></div>
                    <div><a href="http://hkep.com" target="_blank"><p>{{ lang($t("HKEP.com")) }}</p></a></div>
                    <div class="remark"><p>© 1999-2018Hong Kong Educational Publishing Co.<br />All rights reserved.</p></div>
                </div>
                <!--end body-->

            </div>


            <!--end mobile left menu-->
        </mq-layout>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import router from '@js/routes';
    import {cate} from '@store/cate';
    import EventBus from '@common/eventBus';
    import api from '@js/api';
    import axios from 'axios';

    export default {
        name: "NswMenu",
        mixins:[common, storeMapper],
        props: {
            isShowDesktopMenu: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                isShowMobileMenu:false,
                isShowMobileSetting:false,
                mainCateHeight:0,
                display_name: "",
                member_avatar: "",
                userrole: "Teacher",
                showLoginBtn: false
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                if (this.$refs.mainCateContainer !== undefined) {
                    this.mainCateHeight = this.$refs.mainCateContainer.clientHeight;
                }
            });

            EventBus.$on("openMobileMenu", this.openMobileMenu);
            EventBus.$on("closeMobileMenu", this.closeMobileMenu);

            this.isLoggedIn();
            this.listenEvents();
        },
        methods: {
            listenEvents()
            {
                EventBus.$on("refreshMenu", ()=>{
                    this.refreshMenu();
                });
            },
            refreshMenu()
            {
                EventBus.$emit("showGlobalLoading");

                Promise.all(
                    [
                        api.getMainCate()
                    ]
                    .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate) => {

                        if (responseMainCate) {

                            this.$store.commit('cate/setCateItem', responseMainCate.data.maincate);
                        }

                        EventBus.$emit("hideGlobalLoading");


                    })
                );
            },
            logout() {
                let self = this;
                EventBus.$emit("showGlobalLoading");
                api.userLogout().then(resp=> {
                    self.isLoggedIn();
                    var url = window.location.protocol+"//"+window.location.host;
                    window.location.href = url;
                    EventBus.$emit("hideGlobalLoading");
                }).catch(function (resp) {
                    self.isLoggedIn();
                    EventBus.$emit("hideGlobalLoading");

                });
            },
            styleCateItem(color, bgcolor) {
                return {
                    color:color,
                    background: bgcolor ? bgcolor : 'inherit'
                }
            },
            styleSubCateItem(color, bgcolor) {
                return {
                    color:color,
                    background: bgcolor,
                    top:`${this.mainCateHeight}px`
                }
            },
            styleMobileCateIndicator(bgcolor) {
                return {
                    background: bgcolor
                }
            },
            classCateItem(index) {
                return {
                    'sub-cat-align-left': index <= Math.ceil(this.storeCate.cateItem.length / index),
                    'sub-cat-align-right': index > Math.ceil(this.storeCate.cateItem.length / index)
                }
            },
            styleSubCateLink(color) {
                return {
                    color:color
                }
            },
            redirectTo(uri)
            {
                router.push({
                    name: uri
                });
            },
            handleSubCateAction(action, actionValue, cateItemId, subcateItemId) {

                //check is logged in
                if (!this.checkIsLoggedIn()) {
                    EventBus.$emit("showLogin");
                    return false;
                }


                //TODO: use action config

                if (action === "url") {
                    window.open(actionValue, "_blank");
                } else if ( action === "enter_subcate") {
                    //如果在 resource table 頁面, 按下跟當前頁面相同的 main cate 和 sub cate, 那就不做轉頁動作
                    if (
                        this.$router.currentRoute.params.cate_id  === cateItemId  &&
                        this.$router.currentRoute.params.subcate_id  ===  subcateItemId &&
                        this.$router.currentRoute.name ===  "SubCateList"
                    ) {
                        return;
                    }

                    let route_params = {
                        name:'SubCateList',
                        params: {
                            cate_id:cateItemId,
                            subcate_id: subcateItemId
                        }
                    };

                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const status = urlParams.get('status')
                    if (status) {
                        route_params = {
                            name:'SubCateList',
                            params: {
                                cate_id:cateItemId,
                                subcate_id: subcateItemId
                            },
                            query: {
                                status: status
                            }
                        };
                    }


                    router.push(route_params)
                    .catch(error => {
                        if (error.name != "NavigationDuplicated") {
                            throw error;
                            }
                    })


                } else if ( action == "pop_message") {
                    //TBC
                }
            },
            /**
             * Show My Download panel on narrow screen (e.g. on mobile)
             */
            showMyDownload() {
                EventBus.$emit("showMyDownload", "top");
            },
            /**
             * Show setting panel on narrow screen (e.g. on mobile)
             */
            showSetting() {
                this.isShowMobileSetting = true;
            },
            /**
             * Close setting panel on narrow screen (e.g. on mobile)
             */
            closeSetting() {
                this.isShowMobileSetting = false;
            },
            /**
             * Show My Download on narrow screen (e.g. on mobile
             */
            showDownload() {

            },
            onMouseEnter() {
                //console.log("on mouse enter")
                EventBus.$emit("onMenuEnter")
            },
            onMouseLeave() {
                //console.log("on mouse leave")
                EventBus.$emit("onMenuLeave")
            },
            openMobileMenu() {
                this.isLoggedIn();

                this.isShowMobileMenu = true;
                Vue.nextTick(()=>{
                    if (this.$refs.mobileMenu !== undefined) {
                        let menuHeight = this.$refs.mobileMenu.scrollHeight;
                        document.querySelector('#app').style.height = '100%';
                        document.querySelector('#app').style.overflowY = "hidden";
                    }
                })
            },
            closeMobileMenu() {
                this.isShowMobileMenu = false;
            },
            isLoggedIn()
            {
                if (this.checkIsLoggedIn()) {
                    this.display_name = display_name;
                    this.member_avatar = member_avatar;
                    this.userrole = this.getUserRole(member_role);
                    this.showLoginBtn = true;

                } else {
                    this.display_name = "";
                    this.showLoginBtn = false;

                    this.member_avatar = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
                    this.userrole = "";

                }
            },

        },
        updated() {
            if (this.$refs.mainCateContainer !== undefined) {
                this.mainCateHeight = this.$refs.mainCateContainer.clientHeight;
            }
        },
        watch: {
            $mq(value) {
                if (this.$mq === 'narrow') {
                    this.isShowMobileMenu = false;
                } else if (this.$mq === 'wide') {
                   this.resetMainAppSize();
                }

                this.isLoggedIn();
            }
        },
        computed:
        {
            relation_url()
            {
                return this["mainSite/getRelationURL"];
            },
            relation_lang()
            {
                return this['mainSite/getRelatedLangStr'];
            }
        }

    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .main-category {
        width: 100%;
    }

    .main-category>ul {
        width: 100%;
        display: flex;
    }

    .main-category>ul>li {
        text-align: center;
        color: #fff;
        padding: 0.75rem 0.625rem;
        cursor: pointer;
        width: 100%;
        position: relative;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .main-category>ul>li p {
        @extend %font-maincate;
    }

    .main-category>ul>li:hover {
        padding-top: 1rem;
        padding-bottom: .5rem;
    }
    /*.main-category li:hover:before, .main-category li.on:before{width:100%;height:0px;}*/
    .main-category>ul>li>p {
        line-height: 120%;
        color: #fff;
    }

    .main-category>ul>li>div {
        width: 3rem;
        height: 3rem;
        margin: 0 auto 0.375rem;
    }

    .main-category>ul>li>div>img {
        width: 100%;
    }

    .main-category li:hover .sub-cat {
        display: block;
    }

    .sub-cat {
        text-align: left;
        display: none;
        width: 25rem;
        position: absolute;
        z-index: 10;
        padding: 2rem 2rem 1rem 2rem;
        -webkit-radius: 0 0 6px 6px;
        -moz-border-radiust: 0 0 6px 6px;
        border-radius: 0 0 6px 6px;
        -webkit-box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.1);
        box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.1);
    }

    .sub-cat li {
        width: 50%;
        float: left;
        margin-bottom: 1rem;
        opacity: 0.8;
    }

    .sub-cat li:hover {
        text-decoration: underline;
        opacity: 1;
    }

    .sub-cat li {
        padding-right: 2rem;
    }

    //dynamically set by Vue
    .sub-cat-align-left {
        left:0;
    }

    //dynamically set by Vue
    .sub-cat-align-right {
        right:0;
    }

    //mobile-left-menu
    .mobile-left-menu {
        z-index: 105;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background-color: #fff;
        height: 100%;
    }

    .mobile-menu-head .head-lv1 {
        padding: 1rem;
        display: inline-flex;
        width: 100%;
    }

    .mobile-menu-head .head-lv1>div:first-child {
        flex-grow: 1;
        display: inline-flex;
    }

    .mobile-menu-head .head-lv1>div:last-child {
        flex-grow: 0;
    }

    .mobile-menu-head .head-lv2 {
        display: flex;
        height: 3rem;
        width: 100%;
    }

    .mobile-menu-head .head-lv2 div {
        @extend %text-secondary;
        border-right: 1px solid #fff;
        width: 100%;
        text-align: center;
        line-height: 3rem;
        cursor: pointer;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .mobile-menu-head .head-lv2 div:hover {
        @extend %hover-dimmer;
    }

    .mobile-menu-head .head-lv2 div.on {
        color: #fff;
    }

    .mobile-menu-head .head-lv2 div:last-child {
        border: 0px;
    }

    .mobile-menu-head .profile-pic {
        position: relative;
        float: none;
        width: 3rem;
        height: 3rem;
        margin-right: 1rem;
    }

    .mobile-menu-head .profile-name p {
        font-size: 1.125rem;
    }

    .mobile-menu-head .profile-name span {
        color: #a3a3a3;
        padding-top: .5rem;
        display: block;
    }

    .mobile-left-menu .mobile-menu-head a {
        float: right;
        display: block;
        width: 1.25rem;
        height: 1.25rem;
        margin-left: 1.5rem;
    }

    .mobile-menu-body>ul {
        background:#fff;
    }

    .mobile-menu-body>ul>li {
        width: 100%;
        padding: 1.25rem 1.25rem 1.25rem 1.75rem;
        margin: .125rem 0;
        position: relative;
        cursor: pointer;
        background:#fff;
    }


    .mobile-menu-body>ul>li .indicator {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: .5rem;
        background: #000;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .mobile-menu-body>ul>li:hover .indicator {
        width: .75rem;
    }

    .mobile-menu-body>ul>li>p {
        font-size: 1rem;
    }

    .mobile-menu-body>ul>li>ul {
        padding: 1.25rem 0 .25rem .5rem;
    }

    .mobile-menu-body>ul>li>ul>li a {
        width: 100%;
        height: 100%;
        display: block;
        padding: .75rem 0;
    }

    .mobile-menu-body>ul>li>ul>li p {
        color: #8d8d8d;
    }

    .mobile-menu-body>ul>li>ul>li a {
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .mobile-menu-body>ul>li>ul>li:hover a {
        color: #3d3d3d;
        text-decoration: underline;
    }

    .mobile-menu-head .btn-menu svg {
        @extend %fill-secondary;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .mobile-menu-head .btn-menu:hover svg {
        @extend %fill-primary;
    }




</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NswMenu.vue